import { PROGRESS_STATUSES } from 'domain/sales/projectsDashboard/useProjectsDashboardService';
import DoneIcon from '@mui/icons-material/DoneOutlined';
import FailedIcon from '@mui/icons-material/CloseOutlined';
import DelayedIcon from '@mui/icons-material/PriorityHighOutlined';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon/SvgIcon';

export const getProgressFieldIcon = (status: PROGRESS_STATUSES): React.ReactNode => {
  let Icon: Nullable<OverridableComponent<SvgIconTypeMap>> = null;

  switch (status) {
    case PROGRESS_STATUSES.COMPLETED:
      Icon = DoneIcon;
      break;
    case PROGRESS_STATUSES.COMPLETED_WITH_DELAY:
      Icon = DelayedIcon;
      break;
    case PROGRESS_STATUSES.IN_PROGRESS_WITH_DELAY:
      Icon = FailedIcon;
      break;
    default:
      Icon = null;
  }

  return Icon ? <Icon /> : null;
};
